import React from 'react';

// The RESIDENCE Marketing Center is a Canva site. Canva sends X-Frame-Options: SAMEORIGIN, so it cannot be
// embedded here; this page opens it in a new tab instead.
export const MARKETING_CENTER_URL = 'https://homebuyersguide.my.canva.site/residence';

// Static snapshot exported from the Canva design (read-only) and saved in public/.
export const MARKETING_CENTER_PREVIEW = `${process.env.PUBLIC_URL || ''}/marketing-center-preview.jpg`;

export default function MarketingCenter() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 16px', fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>
      <div style={{ background: '#FFFFFF', borderTop: '4px solid #D4AF37', borderRadius: 14, padding: 28, boxShadow: '0 2px 10px rgba(0,0,0,0.06)', textAlign: 'center' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: 26, color: '#1A1A1A' }}>RESIDENCE Marketing Center</h1>
        <p style={{ margin: '0 0 24px', color: '#5B6270', fontSize: 15, lineHeight: 1.5 }}>
          All of the team's Canva templates in one place: social posts, Facebook headers, business cards, signs, announcements, and buyer and seller materials.
        </p>
        <a href={MARKETING_CENTER_URL} target="_blank" rel="noopener noreferrer" aria-label="Open the RESIDENCE Marketing Center in Canva"
          style={{ display: 'block', margin: '0 auto 24px', maxWidth: 480, borderRadius: 12, overflow: 'hidden', border: '1px solid #E5E1D6', boxShadow: '0 4px 14px rgba(0,0,0,0.12)' }}>
          <img src={MARKETING_CENTER_PREVIEW} alt="Preview of the RESIDENCE Marketing Center: business cards, email signature, banners, flyers and more"
            width={800} height={880} loading="lazy"
            style={{ display: 'block', width: '100%', height: 'auto' }} />
        </a>
        <a href={MARKETING_CENTER_URL} target="_blank" rel="noopener noreferrer"
          style={{ display: 'inline-block', padding: '16px 32px', borderRadius: 10, background: '#B8962E', color: '#FFFFFF', fontWeight: 700, fontSize: 18, textDecoration: 'none' }}>
          Open Marketing Center
        </a>
        <p style={{ margin: '16px 0 0', color: '#8A8F99', fontSize: 13 }}>Opens in a new tab.</p>
      </div>
    </div>
  );
}
